module.exports = __webpack_public_path__ + "static/ICONIAMQS-01-71ce0ea7032df9680fd9ca9ebca3f23d.png";